import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import {
  confirmDeletePopup,
  formatDateOnly,
  openAllowanceTypeModal,
  successPopup,
} from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import {
  useCreateNewAllowanceType,
  useGetAllAllowanceTypesPaginated,
  useGetAllowanceTypeById,
  useUpdateAllowanceType,
} from "../../hooks/usePayroll";
import "./sweetalert.css";
import { toast } from "react-toastify";
import {
  _useGetAllShiftSchedules,
  useDeleteShift,
} from "../../hooks/useShiftSchedules";

function ShiftListLayout() {
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    filterField1: "Name",
    filterValue1: null,
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const [shiftScheduleRecords, setShiftScheduleRecords] = useState([]);

  const {
    data: shiftScheduleData,
    isLoading: shiftScheduleIsLoading,
    isError: shiftScheduleIsError,
  } = _useGetAllShiftSchedules({
    page: pagination.page,
    pageSize: pagination.pageSize,
    filterField1: filter.filterField1,
    filterValue1: filter.filterValue1,
  });

  const deleteShift = useDeleteShift();

  useEffect(() => {
    if (shiftScheduleData && shiftScheduleData.data) {
      setShiftScheduleRecords(shiftScheduleData.data.data);
      setPageCount(shiftScheduleData.data.pagination.totalPages);
    }
  }, shiftScheduleData);

  const handleDelete = async (shiftSchedule) => {
    const isConfirmed = await confirmDeletePopup({
      text: `Are you sure you want to delete ${shiftSchedule.Name}?`,
    });

    if (isConfirmed) {
      deleteShift.mutate(shiftSchedule.id, {
        onSuccess: (data) => {
          successPopup({ text: "Shift deleted successfully." });
        },
      });
    }
  };

  const handleEdit = (shiftSchedule) => {
    if (!shiftSchedule) return;
    navigate(`/EditShiftSchedule/${shiftSchedule.id}`);
  };

  const tableColumns = [
    { accessorKey: "Name", header: "Name" },
    { accessorKey: "Description", header: "Description" },
    { accessorKey: "Active", header: "Active" },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const shiftSchedule = row.original;

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <FaEdit
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(shiftSchedule)}
            />

            <FaTrash
              title="Delete"
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(shiftSchedule)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="overtime-form-container">
      <h2>Shift Schedules List</h2>
      <form className="overtime-form">
        <div className="form-column">
          <TextInput
            label="Name"
            placeholder={"My Normal Shift Schedule"}
            onChange={(val) => {
              setFilter((prev) => ({
                ...prev,
                filterValue1: val,
              }));
            }}
            value={filter.filterValue1}
          />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="action-btns">
              <button
                className="overtime-btn"
                onClick={() => navigate("/AddShiftSchedule")}
                type="button"
              >
                + Add Shift Schedule
              </button>
            </div>
            <div className="attendance-records">
              <ReusableTable
                data={shiftScheduleRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ShiftListLayout;
